import cx from 'classnames';
import {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import {useRequestLogin} from '~/common/fabric/Card/components/LoginModal/hooks/useRequestLogin';
import {useIsMediumAndUp} from '~/common/hooks/useMatchQuery';
import {logger} from '~/common/utils/logging';
import {NotOnGuestListModal} from '~/ViewInvitation/routes/Photos/modals';
import {eventHasPassed, isPreview} from '~/ViewInvitation/utils';
import {Button} from '~library/atoms/Button';
import {PlusIcon} from '~library/svg/v2/PlusIcon';

import {coin, white} from '~libSass/base/_exports.sass';

export const PhotoUploadButton = ({
  children,
  variant = 'primary',
  disabled,
  fileUploadRef,
  iconColor = white,
  icon = null,
  fullWidth = false,
  isHostModule,
  preview = isPreview(),
}) => {
  const {loggedIn: isLoggedIn, requestLogin} = useRequestLogin();
  const isMediumAndUp = useIsMediumAndUp();
  const hasRsvpd = useSelector((state) => state.rsvp?.hasRsvpd ?? false);
  const rsvpOff = useSelector((state) => state.eventDetails.rsvpOff);
  const guestId = useSelector(({user}) => user?.guestId);
  const [showNotOnGuestListModal, setShowNotOnGuestListModal] = useState(false);

  const unlockUI = isHostModule || ((eventHasPassed() || hasRsvpd || rsvpOff) && !preview);

  const handlePhotoSelect = useCallback(async () => {
    if (!unlockUI) return false;

    if (!guestId && !isHostModule) {
      if (!isLoggedIn) {
        const loggedIn = await requestLogin();

        if (!loggedIn) {
          return false;
        }

        if (!guestId) {
          // ideally our ajax_login endpoint would return a guestID for this event...
          window.location.reload();
        }
      } else {
        setShowNotOnGuestListModal(true);
        await logger('User has no guest_id for event', 'error', {guestId, wasLoggedIn: true});
      }
    } else {
      fileUploadRef.current.click();
    }
    return true;
  }, [unlockUI, guestId, isHostModule, isLoggedIn, requestLogin, fileUploadRef]);

  return (
    <>
      <Button
        variant={variant}
        data-qa-id="add-photos-button"
        className={cx('photos__add-photos-button', {
          'photos__add-photos-button__disabled': !unlockUI,
        })}
        disabled={disabled || !unlockUI}
        onClick={handlePhotoSelect}
        size="medium"
        tight={!isMediumAndUp}
        fullWidth={fullWidth}
        icon={icon ?? <PlusIcon ratio={0.75} color={disabled || !unlockUI ? coin : iconColor} />}
        ariaLabel="upload photos"
      >
        {children}
      </Button>
      {showNotOnGuestListModal && (
        <NotOnGuestListModal onClose={() => setShowNotOnGuestListModal(false)} />
      )}
    </>
  );
};
